import { money, pageInfo } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const V2ATransferHistory = gql`
  query GetV2ATransferHistory($after: String) {
    v2aTransfers(after: $after) {
      edges {
        node {
          id
          note
          status
          createdAt
          from {
            first
            last
            initials
            full
          }
          to {
            id
            displayName
            phoneNumber
            email {
              address
            }
          }
          value {
            ...money
          }
          details {
            items {
              id
              title
              description
            }
          }
        }
      }
      pageInfo {
        ...pageInfo
      }
    }
  }
  ${money}
  ${pageInfo}
`;

export default V2ATransferHistory;
